<section class="cmn-innerpage-wrapper add-project-inventory">
  <h2 class="cmn-inner-heading">
    {{ refundId ? "Edit Refund" : "New Refund" }}
  </h2>
  <form [formGroup]="refundForm" (ngSubmit)="onSubmit()">
    <!-- Format Selection -->
    <div class="chart-account-form-wrapper">
      <div class="form-wrapper">
        <label for="">Customer <span class="red">*</span></label>
        <mat-form-field appearance="fill">
          <mat-label>Select Customer</mat-label>
          <mat-select formControlName="customerId">
            <mat-option>
              <ngx-mat-select-search
                [placeholderLabel]="'Search'"
                [noEntriesFoundLabel]="'No customers found'"
                (input)="onSearch($event)"
              ></ngx-mat-select-search>
            </mat-option>
            <mat-option
              *ngFor="let customer of customers"
              [value]="customer.id"
            >
              {{ customer.firstName }} {{ customer.lastName }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <div class="custom-error">
          <mat-error
            *ngIf="
              refundForm.get('customerId')?.touched &&
              refundForm.get('customerId')?.hasError('required')
            "
          >
            Customer is required.
          </mat-error>
        </div>
      </div>
      <!-- 
      <div class="form-wrapper">
        <label for="">Customer</label>
        <mat-form-field appearance="fill">
          <input
            matInput
            [value]="selectedCustomer"
            placeholder="Customer"
          />
        </mat-form-field>
      </div> -->

      <div class="form-wrapper">
        <label for="">Invoice <span class="red">*</span></label>
        <mat-form-field appearance="fill">
          <mat-label>Choose invoice</mat-label>
          <mat-select
            (openedChange)="onInvoiceAvailable($event)"
            formControlName="invoiceId"
          >
            <mat-option>
              <ngx-mat-select-search
                [placeholderLabel]="'Search'"
                [noEntriesFoundLabel]="'No invoice found'"
                (input)="onSearch($event)"
              ></ngx-mat-select-search>
            </mat-option>
            <mat-option
              *ngFor="let invoice of paidInvoiceData"
              [value]="invoice.id"
            >
              {{ invoice.invoiceNo }}
            </mat-option>
            <mat-option *ngIf="paidInvoiceData?.length === 0" disabled>
              No invoice available for the selected customer
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div class="custom-error">
          <mat-error
            *ngIf="
              refundForm.get('invoiceId')!.touched &&
              refundForm.get('invoiceId')!.hasError('required')
            "
          >
            Invoice is required.
          </mat-error>
        </div>
      </div>

      <div class="form-wrapper">
        <div class="refund-amt">
          <label for="">Amount <span class="red">*</span></label>
          <label *ngIf="maxRefund" for="">Maximum refund amount <span class="red">{{maxRefundAmount}}</span></label>
        </div>

        <mat-form-field>
          <input
            matInput
            placeholder="Enter Amount"
            formControlName="amount"
            (keypress)="allowOnlyNumberWithDecimal($event)"
            (paste)="blockPaste($event)"
          />
        </mat-form-field>
        <div class="custom-error">
          <span>
            <mat-error
              *ngIf="
                refundForm.get('amount')!.touched &&
                refundForm.get('amount')!.hasError('required')
              "
              >Amount is required.</mat-error
            >
            <mat-error *ngIf="refundForm.get('amount')?.hasError('maxAmount')">
              Amount should not exceed paid amount ({{ maxRefundAmount }}).
            </mat-error>
          </span>
        </div>
      </div>

      <div class="form-wrapper">
        <label for="">Currency</label>
        <mat-form-field appearance="fill">
          <input matInput value="AED" readonly />
        </mat-form-field>
      </div>

      <div class="form-wrapper">
        <label for="">Refund Date <span class="red">*</span></label>
        <mat-form-field appearance="fill">
          <input
            matInput
            [matDatepicker]="picker"
            placeholder="Choose a date"
            formControlName="refundDate"
            [min]="today"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
        <div class="custom-error">
          <mat-error
            *ngIf="
              refundForm.get('refundDate')?.touched &&
              refundForm.get('refundDate')?.hasError('required')
            "
          >
            Refund Date is required.
          </mat-error>
        </div>
      </div>

      <div class="form-wrapper">
        <label for="">Payment Method <span class="red">*</span></label>
        <mat-form-field appearance="fill">
          <mat-label>Choose payment method</mat-label>
          <mat-select formControlName="paymentMethod">
            <mat-option
              *ngFor="let type of paymentMethodData"
              [value]="type.value"
            >
              {{ type.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div class="custom-error">
          <mat-error
            *ngIf="
              refundForm.get('paymentMethod')!.touched &&
              refundForm.get('paymentMethod')!.hasError('required')
            "
          >
            Payment method is required is required.
          </mat-error>
        </div>
      </div>

      <!-- Cheque No  -->
      <div
        class="form-wrapper"
        *ngIf="refundForm.get('paymentMethod')?.value === 'Cheque'"
      >
        <label for="">Cheque No <span class="red">*</span></label>
        <mat-form-field>
          <input
            matInput
            placeholder="Enter Cheque No"
            formControlName="chequeNo"
          />
        </mat-form-field>
        <div class="custom-error">
          <mat-error
            *ngIf="
              refundForm.get('chequeNo')!.touched &&
              refundForm.get('chequeNo')!.hasError('required')
            "
          >
            Cheque number is required.
          </mat-error>
        </div>
      </div>

      <!-- Cheque Date -->
      <div
        class="form-wrapper"
        *ngIf="refundForm.get('paymentMethod')?.value === 'Cheque'"
      >
        <label for="">Cheque Date <span class="red">*</span></label>
        <mat-form-field appearance="fill">
          <input
            matInput
            [matDatepicker]="chequeDatePicker"
            formControlName="chequeDate"
            placeholder="Pick a date"
            [min]="today"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="chequeDatePicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #chequeDatePicker></mat-datepicker>
        </mat-form-field>
        <div class="custom-error">
          <mat-error
            *ngIf="
              refundForm.get('chequeDate')!.touched &&
              refundForm.get('chequeDate')!.hasError('required')
            "
          >
            Cheque date is required.
          </mat-error>
        </div>
      </div>

      <div class="form-wrapper">
        <label for="">Account <span class="red">*</span></label>
        <mat-form-field appearance="fill">
          <mat-label>Choose Account</mat-label>
          <mat-select formControlName="accountId">
            <mat-option
              *ngFor="let account of accountsData"
              [value]="account.id"
            >
              {{ account.accountName }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div class="custom-error">
          <mat-error
            *ngIf="
              refundForm.get('accountId')!.touched &&
              refundForm.get('accountId')!.hasError('required')
            "
          >
            Account is required.
          </mat-error>
        </div>
      </div>

      <div class="form-wrapper">
        <label for="">Reference Number <span class="red">*</span></label>
        <mat-form-field>
          <input
            matInput
            placeholder="Enter reference number"
            formControlName="referenceNumber"
          />
        </mat-form-field>
        <div class="custom-error">
          <span>
            <mat-error
              *ngIf="
                refundForm.get('referenceNumber')!.touched &&
                refundForm.get('referenceNumber')!.hasError('required')
              "
              >Reference Number is required.</mat-error
            >
          </span>
        </div>
      </div>

      <div class="form-wrapper">
        <label for="">Notes </label>
        <mat-form-field>
          <input matInput placeholder="Notes" FormControlName="notes" />
        </mat-form-field>
        <div class="custom-error"></div>
      </div>
    </div>

    <div class="submit-btn-wrapper">
      <button class="cmn-cancel-btn" type="button" (click)="onCancel()">
        Cancel
      </button>
      <button class="cmn-next-btn" type="submit">Save</button>
    </div>
  </form>
</section>
